import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozMetaDataDisplay', bringozMetaDataDisplay);

function bringozMetaDataDisplay() {
  return function bringozMetaDataDisplayFilter(entityMetaDataList, selectedMetaData) {
    if (!entityMetaDataList) {
      entityMetaDataList = [];
    }
    const metaDataFound = _.find(entityMetaDataList.reverse(), function (m) {
      return _.get(m, 'key') === _.get(selectedMetaData, 'key', false);
    })
    return _.get(metaDataFound, 'value', '---');
  }
}
